import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verificar si el usuario está autenticado
  if (authService.isAuthenticated() && authService.hasValidToken()) {
    return true;
  }

  // Si no está autenticado, redirigir al login
  router.navigate(['/admin/login'], {
    queryParams: { returnUrl: state.url }
  });
  
  return false;
};
